

export const MixpanelEvents = {
    FREE_SLOT_DELETION_ATTEMPTED: "Free Slot Deletion Attempted",
    NOT_CONDUCTED_CLASS: "Marked as not conducted",
    MEMBERSHIP_UPDATE:"Membership update",
    MARK_AS_COMPLETED:"Mark as completed class",
    FORCE_COMPELETE_CLASS:"Force complete class",
    MARK_AS_COMPLETE_NOT_CONDUCTED:"Mark as complete not conducted",
    MARK_AS_NOSHOW:"Mark as noshow",
    MARK_AS_TEACHER_NOSHOW:"Mark as teacher noshow",
    MARK_AS_JOIN:"Mark As join",
    TEACHER_CHANGE_DETACHMENT:"Teacher Change Detachment",
    MARK_AS_STUDENT_NOSHOW:"Mark as student noshow",
    RESCHEDULE_CLASS:"Reschedule class",
    SCHEDULE_CLASS:"schedule class",
    BOOKING_FREQUENCY_LANDED: "Admin Booking Frequency Landed",
    BOOKING_FREQUENCY_SELECTED: "Admin Booking Frequency Selected",
    BOOKING_FREQUENCY_SUCCESS: "Admin Booking Frequency Success",
    CANCEL_CLASS:"Cancel the class",
    TEACHER_CHANGE:"Teacher Change action",
    COURSE_CHANGE:"Change Course",
    LEVEL_CHANGE:"Change Level",
    COURSE_TRANSFER:"Course Transfer",
    EXTEND_EXPIRY:"Extend Expiry",
    COURSE_TAGGING:"Course Tagged",
    TEACHER_PROFILE_UPDATE:"Teacher Profile update",
    STUDENT_PROFILE_UPDATE:"Student profile",
    POLICY_CHANGE:"Policy Change",
    THIRTY_MIN_CLASS_TOGGLE: "30 Min Class Toggle",
    PAYMENT_PACKAGE:"Payment Package and transaction list",
    SPLIT_PAYMENT_CREATED:"Split Payment Created",
    SPLIT_PAYMENT_UPDATED:"Split Payment Link Updated",
    SPLIT_PAYMENT_MARKED_EXTERNAL:"Split Payment Marked External",
    ENABLE_FOR_PAID:"Enable For Paid",
    TEACHER_STATUS_CHANGE:"Teacher Status Change",
    AI_SUMMARY:"AI Summary",
    COMPLETED_LEVEL:"Complete the Level",
    MARK_AS_COMPLETE_LEVEL:"Mark level as complete",  
    MARK_AS_UNCOMPLETE_LESSON:"Mark as uncomplete lesson",
    MARK_AS_COMPLETE_LESSON:"Mark as complete lesson",
    OFFLINE_COURSE_ENROLLMENT:"Offline Course Enrollment",
    FIND_TEACHER_SEARCH:"Find Teacher Search",
    FIND_TEACHER_ALTERNATE_SEARCH:"Find Teacher Alternate Search",
    ADD_TO_COMMUNITY:"Add Student to Community",
    REMOVE_FROM_COMMUNITY:"Remove Student from Community",
    QA_REPORT_PAGE_VIEW:"QA Report Page View",
    QA_REPORT_NEXT_PAGE:"QA Report Next Page",
    QA_REPORT_PREVIOUS_PAGE:"QA Report Previous Page",
    QA_REPORT_SUBMITTED:"QA Report Submitted",
    QA_REPORT_SUBMISSION_FAILED:"QA Report Submission Failed",
    QA_REPORT_VALIDATION_ERROR:"QA Report Validation Error",
    COURSE_EXTENSION_MODAL_OPENED: "Course Extension Modal Opened",
    COURSE_EXTENSION_LINK_CREATED: "Course Extension Link Created",
    COURSE_EXTENSION_LINK_CREATE_FAILED: "Course Extension Link Create Failed",
    COURSE_EXTENSION_LINK_COPIED: "Course Extension Link Copied",
    COURSE_EXTENSION_SHARE_LINK_CLICKED: "Course Extension Share Link Clicked",
    COURSE_EXTENSION_DELETED: "Course Extension Deleted",
    COURSE_EXTENSION_DELETE_FAILED: "Course Extension Delete Failed",
    COURSE_EXTENSION_CREATE_ANOTHER: "Course Extension Create Another",
  TEACHER_LEAVE: "Teacher Leave",
  TEACHER_LEAVE_BALANCE_UPDATED: "Teacher Leave Balance Updated",
  TEACHER_LEAVE_APPLIED: "Teacher Leave Applied",
  COMMUNITY_OPS_PAGE_VIEW: "Community Ops Page View",
  COMMUNITY_OPS_CADENCE_SYNC_SUCCESS: "Community Ops Cadence Sync Success",
  COMMUNITY_OPS_CADENCE_SYNC_FAILED: "Community Ops Cadence Sync Failed",
  COMMUNITY_OPS_SHEET_UPLOAD_SUCCESS: "Community Ops Sheet Upload Success",
  COMMUNITY_OPS_SHEET_UPLOAD_FAILED: "Community Ops Sheet Upload Failed",
  COMMUNITY_OPS_BROADCAST_CREATED: "Community Ops Broadcast Created",
  COMMUNITY_OPS_BROADCAST_CREATE_FAILED: "Community Ops Broadcast Create Failed",
  COMMUNITY_OPS_BROADCAST_UPDATED: "Community Ops Broadcast Updated",
  COMMUNITY_OPS_BROADCAST_UPDATE_FAILED: "Community Ops Broadcast Update Failed",
  COMMUNITY_OPS_BROADCAST_DELETED: "Community Ops Broadcast Deleted",
  COMMUNITY_OPS_BROADCAST_DELETE_FAILED: "Community Ops Broadcast Delete Failed",
  TEACHER_BULK_DELETE_FREE_SLOTS: "Teacher Bulk Delete Free Slots",
  TEACHER_LEDGER_DATA_LOADED: "Teacher Ledger Data Loaded",
  TEACHER_LEDGER_DATA_LOAD_FAILURE: "Teacher Ledger Data Load Failure",
  TEACHER_LEDGER_ADJUSTMENT_SUBMITTED_SUCCESS: "Teacher Ledger Adjustment Submitted Success",
  TEACHER_LEDGER_ADJUSTMENT_SUBMITTED_FAILURE: "Teacher Ledger Adjustment Submitted Failure",
  TEACHER_LEDGER_DISPUTE_REJECTED_SUCCESS: "Teacher Ledger Dispute Rejected Success",
  TEACHER_LEDGER_DISPUTE_REJECTED_FAILURE: "Teacher Ledger Dispute Rejected Failure",
  DEMO_RESCHEDULE: "Demo-Class-ReScheduled-Success",
  DEMO_BOOK: "Demo-Class-Scheduled-Success",
  DEMO_REASSIGN_TEACHER: "Demo Class Reassign Teacher",
  TEACHER_LEADER_TEACHERS_ASSIGNED: "Teacher Leader Teachers Assigned",
  TEACHER_LEADER_TEACHERS_ASSIGN_FAILED: "Teacher Leader Teachers Assign Failed",
  TEACHER_LEADER_TEACHERS_REMOVED: "Teacher Leader Teachers Removed",
  TEACHER_LEADER_ROLE_ASSIGNED: "Teacher Leader Role Assigned",
  TEACHER_LEADER_ROLE_ASSIGN_FAILED: "Teacher Leader Role Assign Failed",
  TEACHER_LEADER_ROLE_REMOVED: "Teacher Leader Role Removed",
  TEACHER_LEADER_CREATED: "Teacher Leader Created",
  TEACHER_LEADER_CREATE_FAILED: "Teacher Leader Create Failed",
  DEMO_COMPLETE_CLASS: "Demo Complete Class",
  DEMO_CANCEL_CLASS: "Demo Cancel Class",
  TEACHER_SCHEDULE_PUBLISHED: "Teacher Schedule Published",
  TEACHER_SCHEDULE_RESET_ALL: "Teacher Schedule Reset All",
  TEACHER_SCHEDULE_DAY_CLEARED: "Teacher Schedule Day Cleared",
  TEACHER_AE_LEAVE_APPLIED: "Teacher AE Leave Applied",
  DEMOOPS_AGENT_STATUS_CHANGED: "DemoOps Agent Status Changed",
  DEMOOPS_AGENT_STATUS_API_FAILURE: "DemoOps Agent Status API Failure",
  DEMOOPS_AGENT_STATUS_TOGGLE_ERROR: "DemoOps Agent Status Toggle Error",
  DEMOOPS_LEAD_SAVE_SUCCESS: "DemoOps Lead Save Success",
  DEMOOPS_LEAD_SAVE_FAILED: "DemoOps Lead Save Failed",
  DEMOOPS_SHIFT_ADD: "DemoOps Shift Add",
  DEMOOPS_SHIFT_DELETE: "DemoOps Shift Delete",
  DEMOOPS_SHIFT_UPDATE: "DemoOps Shift Update",
  AE_CALENDAR_SLOT_ADDED: "AE Calendar Slot Added",
  AE_CALENDAR_SLOT_ADD_FAILED: "AE Calendar Slot Add Failed",
  AE_CALENDAR_FREE_SLOT_DELETED: "AE Calendar Free Slot Deleted",
  AE_CALENDAR_FREE_SLOT_DELETE_FAILED: "AE Calendar Free Slot Delete Failed",
  CALENDAR_SLOT_INSERTED: "Calendar Slot Inserted",
  CALENDAR_SLOT_INSERT_FAILED: "Calendar Slot Insert Failed",
  STUDENT_CREATED: "Student Created",
  STUDENT_CREATE_FAILED: "Student Create Failed",
  OFFLINE_STUDENT_CREATED: "Offline Student Created",
  OFFLINE_STUDENT_CREATE_FAILED: "Offline Student Create Failed",
  TEACHER_CREATED: "Teacher Created",
  TEACHER_CREATE_FAILED: "Teacher Create Failed",
  QA_ADMIN_AUDIT_CREATED: "QA Admin Audit Created",
  QA_ADMIN_AUDIT_CREATE_FAILED: "QA Admin Audit Create Failed",
  QA_ADMIN_AUDIT_UPDATED: "QA Admin Audit Updated",
  QA_ADMIN_AUDIT_UPDATE_FAILED: "QA Admin Audit Update Failed",
  QA_POLICY_REPORT_GENERATED: "QA Policy Report Generated",
  QA_POLICY_REPORT_GENERATE_FAILED: "QA Policy Report Generate Failed",
  TEACHER_PAYOUT_UPLOADED: "Teacher Payout Uploaded",
  TEACHER_PAYOUT_UPLOAD_FAILED: "Teacher Payout Upload Failed",
  TEACHER_PAYOUT_DELETED: "Teacher Payout Deleted",
  TEACHER_PAYOUT_DELETE_FAILED: "Teacher Payout Delete Failed",
  TEACHER_COMPENSATION_REPORT_REQUESTED: "Teacher Compensation Report Requested",
  TEACHER_COMPENSATION_REPORT_FAILED: "Teacher Compensation Report Failed",
  TEACHER_LEDGER_ADJUSTMENT_SUBMITTED_SUCCESS: "Teacher Ledger Adjustment Submitted Success",
  TEACHER_LEDGER_ADJUSTMENT_SUBMITTED_FAILURE: "Teacher Ledger Adjustment Submitted Failure",
  // DEMO_RESCHEDULE: "Demo Class Reschedule",
  // DEMO_BOOK: "Demo Class Book",
  // DEMO_REASSIGN_TEACHER: "Demo Class Reassign Teacher",
  // DEMO_COMPLETE_CLASS: "Demo Complete Class",
  // DEMO_CANCEL_CLASS: "Demo Cancel Class",
  CREATE_CLASS:"Reacord Paymnet Create Class",
  SLOT_ANALYSIS_PAGE_VIEW: "Slot Analysis Page View",
  SLOT_ANALYSIS_HEATMAP_LOADED: "Slot Analysis Heatmap Loaded",
  SLOT_ANALYSIS_CONDUCT_LOADED: "Slot Analysis Conduct Convert Loaded",
  SLOT_ANALYSIS_CSV_EXPORT: "Slot Analysis CSV Export",
  TEACHER_ESCALATION_PAGE_VIEW: "Teacher Escalation Page View",
  TEACHER_ESCALATION_TAB_CHANGED: "Teacher Escalation Tab Changed",
  TEACHER_ESCALATION_RAISE_MODAL_OPENED: "Teacher Escalation Raise Modal Opened",
  TEACHER_ESCALATION_RAISED: "Teacher Escalation Raised",
  TEACHER_ESCALATION_RAISE_FAILED: "Teacher Escalation Raise Failed",
  TEACHER_ESCALATION_VALIDATED: "Teacher Escalation Validated",
  TEACHER_ESCALATION_VALIDATION_FAILED: "Teacher Escalation Validation Failed",
  TEACHER_ESCALATION_ACTION_RECORDED: "Teacher Escalation Action Recorded",
  TEACHER_ESCALATION_ACTION_FAILED: "Teacher Escalation Action Failed",
  TEACHER_ESCALATION_CSV_EXPORT: "Teacher Escalation CSV Export",
  TEACHER_ESCALATION_CSV_EXPORT_FAILED: "Teacher Escalation CSV Export Failed",
  TEACHER_ESCALATION_DETAIL_VIEWED: "Teacher Escalation Detail Viewed",
  // CREATE_CLASS:"Reacord Paymnet Create Class"
};

export const trackEvent = (eventName, properties = {}) => {
  if (!window.mixpanel) return;

  const userId = localStorage.getItem("userId");
  const profileData = JSON.parse(localStorage.getItem("profileData") || "{}");

  const baseProperties = {
    $loginUserId:userId,
    $login_user_name: profileData.firstName ?? "",
    $login_user_lastname: profileData.lastName ?? "",
    AdminRole: profileData.role ?? "",
    page: window.location.pathname,
  };

  window.mixpanel.track(eventName, { ...baseProperties, ...properties });
};
